module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dashboard.namespaces.namespaceColumnHeading":"Namespace","dashboard.namespaces.totalColumnHeading":"Total","dashboard.namespaces.nodata":"There is no namespace spend data in the selected date range"}}')
  delete Component.options._Ctor
}
